import ApiConstants from "../../Constants/ApiConstant";
import { apiGet } from "../../Services/ApiService";

export const getDashboardDetailsAPI = (data, callBack) => {
    return async () => {
      try {
        await apiGet(ApiConstants.dashboardUrl, data)
          .then((response) => {
            callBack && callBack(response?.data, response?.data);
          })
          .catch((err) => {
            console.log("get dashboard details api err===-=>>>:", err);
            throw err;
          });
      } catch (err) {
        console.log("get dashboard details api err:", err);
        throw err;
      }
    };
  };